//funzioni selettrici
const x = (element) => document.querySelector(element); //query selector scorciato
const $a = (elements) => Array.from(document.querySelectorAll(elements)); //query selectorAll in formato array
const $an = (elements) => document.querySelectorAll(elements); //querySelectorAll in formato nodeList

//funzione creazione elemento con classe e attributi
const newElement = (type, className, attributes) => {
  let element;

  if (type != "") {
    element = document.createElement(type);
    element.className = className;

    try {
      if (attributes && attributes.length > 0) {
        attributes.forEach((attribute) => {
          attribute.value &&
            element.setAttribute(attribute.name, attribute.value);
        });
      }
    } catch (error) {
      alert(
        `Si è verificato un errore durante la creazione dell'elemento ${type} con className = ${className}`
      );
    }
  }

  return element;
};

//funzioni per aggiunta, rimozione, attivazione e cancellazione filtri
//tutte le funzioni si basano su un'oggetto che si chiama shopUtils.
//shop utils è un oggetto globale creato dallo script utils, implementato in theme.liquid in modo che sia presente in ogni pagina

function triggerFilter(e) {
  if (e.target) {
    debugger;
    let autoApply = window.innerWidth > 768;
    let mode = e.target.getAttribute("data-filter-mode");
    let filter = {
      type: e.target.getAttribute("data-filter-type"),
      value: e.target.getAttribute("data-filter-value"),
    };

    changeAspectOfFilterTriggers(e.target, mode);

    if (mode == "add") {
      addFilter(filter, autoApply);
    } else {
      removeFilter(filter, autoApply);
    }
  }
}
function addFilter(filter, autoApply) {
  if (filter && filter.type && filter.value) {
    switch (filter.type) {
      case "tag":
        let isTagInNextTags = shopUtils.nextTags.find(
          (item) => item == filter.value
        );
        !isTagInNextTags && shopUtils.nextTags.push(filter.value);
        break;
      default:
        let isFilterInNextFilters = shopUtils.nextFilters.find(
          (item) =>
            item.parameter === filter.type && item.value === filter.value
        );
        !isFilterInNextFilters &&
          shopUtils.nextFilters.push({
            parameter: filter.type,
            value: filter.value,
          });
        break;
    }
    autoApply && applyFilters();
  }
}
function removeFilter(filter, autoApply) {
  if (filter && filter.type && filter.value) {
    switch (filter.type) {
      case "tag":
        shopUtils.nextTags = shopUtils.nextTags.filter(
          (item) => item !== filter.value
        );
      default:
        shopUtils.nextFilters = shopUtils.nextFilters.filter(
          (item) =>
            item.parameter !== filter.type || item.value !== filter.value
        );
    }
    autoApply && applyFilters();
  }
}
function resetNextFilters() {
  //svuoto tag/filtri attivati nel pannello mobile
  shopUtils.nextTags = [];
  shopUtils.nextFilters = [];

  //deseleziono tutti i tag
  $a(".filter-trigger").forEach((filter) => {
    changeAspectOfFilterTriggers(filter, "remove");
  });

  //riseleziono tutti i tag
  shopUtils.active_tags.forEach((tag) => {
    let strippedTag = tag.label.replaceAll(" ", "-");
    let targets = $a(`div[data-filter-type="tag"]`);
    let isFilteringFromMobile = window.innerWidth < 768;
    let tagElement = targets.find((item) => {
      let isTagOk = item.getAttribute("data-filter-value") === strippedTag;
      let isClassOk = isFilteringFromMobile
        ? item.classList.contains("filter-trigger-mobile")
        : !item.classList.contains("filter-trigger-mobile");
      return isTagOk && isClassOk;
    });

    if (tagElement) {
      changeAspectOfFilterTriggers(tagElement, "add");
    }
    shopUtils.nextTags.push(strippedTag);
  });

  //da testare su uno store con dei filtri
  // shopUtils.activeFilters.forEach(filter => {
  //    let target = $(`div[data-filter-type="tag"][data-filter-value="${tag}"]`);
  //    changeAspectOfFilterTriggers(target, "add");
  // })
}
//cambia l'aspetto dei filtri a seconda di cosa è stato selezionato
function changeAspectOfFilterTriggers(target, mode) {
  if (target) {
    let isFilterMobile = target.classList.contains("filter-trigger-mobile");
    let checkBoxMobile = target.querySelector(".filters-panel__item-checkbox");
    let checkBox = target.querySelector(".filter-checkbox");
    if (isFilterMobile) {
      mode == "add"
        ? gsap.to(checkBoxMobile, { backgroundColor: "#C4C4C4", duration: 0.2 })
        : gsap.to(checkBoxMobile, {
            backgroundColor: "#ffffff",
            duration: 0.2,
          });
    } else {
      mode == "add"
        ? gsap.to(checkBox, {
            backgroundColor: "#ffffff",
            boxShadow: "inset 0px 0px 0px 3px #ffffff",
            duration: 0.2,
          })
        : gsap.to(checkBox, {
            backgroundColor: "#ffffff",
            boxShadow: "unset",
            duration: 0.2,
          });
    }
  }
  target.setAttribute("data-filter-mode", mode == "add" ? "remove" : "add");
}
function applyFilters() {
  debugger;
  let entity = shopUtils.collection ? shopUtils.collection : shopUtils.blog;
  let entityType = shopUtils.collection ? "collections" : "blogs";

  if (entity && window.location.href.includes(entityType)) {
    let newUrl = `${shopUtils.shop.url}/${entityType}/${entity}`;

    if (shopUtils.nextTags && shopUtils.nextTags.length > 0) {
      newUrl += entityType === "collections" ? `/` : `/tagged/`;
      shopUtils.nextTags.forEach((tag) => {
        newUrl += `${tag}+`;
      });
      newUrl = newUrl.substring(0, newUrl.length - 1);
    }

    if (shopUtils.nextFilters && shopUtils.nextFilters.length > 0) {
      newUrl += "?";
      shopUtils.nextFilters.forEach((filter) => {
        if (filter) {
          newUrl += `${filter.parameter}=${filter.value}&`;
        }
      });
      newUrl = newUrl.substring(0, newUrl.length - 1);
    }

    if (shopUtils.nextSort) {
      if (shopUtils.nextFilters && shopUtils.nextFilters.length > 0) {
        newUrl += `&sort_by=${shopUtils.nextSort}`;
      } else {
        newUrl += `?sort_by=${shopUtils.nextSort}`;
      }
    }

    window.location.href = newUrl;
  }
}
function changeSort(value) {
  shopUtils.nextSort = value;
  applyFilters();
}

function addMutationObserver(selector, customCallback) {
  let targetNode = $(selector);
  if (targetNode) {
    let config = { attributes: true, childList: true, subtree: true };
    const callback = function (mutationsList, observer) {
      // Use traditional 'for loops' for IE 11
      for (const mutation of mutationsList) {
        if (mutation.type === "childList") {
          customCallback();
        } else if (mutation.type === "attributes") {
        }
      }
    };

    let observer = null;
    observer = new MutationObserver(callback);
    observer.observe(targetNode, config);
  }
}
